export const PowerToolsRoutes = (urlStart: string) => {
  urlStart = urlStart || "/supportal";

  return [
    { type: "Divider" },
    {
      type: "IconTitle",
      name: "Power Tools",
      icon: "mdi mdi-hammer-wrench",
      color: "dark",
    },
    { type: "Divider" },
    {
      type: "IconLink",
      name: "Schema Comparison",
      icon: "mdi mdi-file-compare",
      path: `${urlStart}/schema-compare`,
      color: "dark",
    },
    {
      type: "IconLink",
      name: "JSON to Schema",
      icon: "mdi mdi-code-json",
      path: `${urlStart}/json-to-schema`,
      color: "dark",
    },
    {
      type: "IconLink",
      name: "Orphan Collections",
      icon: "mdi mdi-database-search",
      path: `${urlStart}/orphan-collections`,
      color: "dark",
    },
    {
      type: "IconLink",
      name: "Sentry",
      icon: "mdi mdi-bug",
      path: `${urlStart}/sentry`,
      color: "dark",
    },
  ];
};

export const MissionControlRoutes = (urlStart: string) => {
  urlStart = urlStart || "/supportal";

  return [
    {
      type: "IconLink",
      name: "Health & Maintenance",
      icon: "mdi mdi-wrench-clock",
      path: `${urlStart}/health-maintenance`,
      color: "dark",
    },
    {
      type: "IconLink",
      name: "Cache Management",
      icon: "mdi mdi-server",
      path: `${urlStart}/cache-management`,
      color: "dark",
    },
    {
      type: "IconLink",
      name: "Clouds",
      icon: "mdi mdi-cloud",
      path: `${urlStart}/clouds`,
      color: "dark",
    },
  ];
};

export const MissionControlCollapseRoutes = (urlStart: string) => {
  return [
    {
      type: "CollapseIconLink",
      name: "CRM Settings",
      icon: "mdi mdi-account-convert",
      color: "light-gray",
      pageType: "Direct",
      children: [
        {
          path: `${urlStart}/global/fieldtypes`,
          name: "Field Types",
        },
        {
          path: `${urlStart}/global/templates`,
          name: "Default Templates",
        },
      ],
    },
    {
      type: "CollapseIconLink",
      name: "Global Variables",
      icon: "mdi mdi-variable",
      color: "light-gray",
      pageType: "Direct",
      children: [
        {
          path: `${urlStart}/global/variables/constants`,
          name: "Constants",
        },
        {
          path: `${urlStart}/global/variables/lists`,
          name: "Lists",
        },
      ],
    },
  ];
};

export const MissionControlHeader = [
  {
    type: "Divider",
  },
  {
    type: "IconTitle",
    name: "Mission Control",
    icon: "mdi mdi-rocket",
    color: "dark",
  },
  {
    type: "Divider",
  },
];

export const SupportalHeader = [
  {
    type: "Divider",
  },
  {
    type: "IconTitle",
    name: "Support",
    icon: "mdi mdi-lifebuoy",
    color: "dark",
  },
  {
    type: "Divider",
  },
];

export const SupportalRoutes = (urlStart: string) => {
  urlStart = urlStart || "/supportal";

  return {
    title: { name: "Support", icon: "mdi mdi-lifebuoy", color: "dark" },
    items: [
      {
        type: "IconLink",
        name: "Clouds",
        icon: "mdi mdi-cloud",
        path: `${urlStart}/clouds`,
        color: "dark",
      },
      {
        type: "IconLink",
        name: "Users",
        icon: "mdi mdi-account",
        path: `${urlStart}/users`,
        color: "dark",
      },
      {
        type: "IconLink",
        name: "Activity Log",
        icon: "mdi mdi-clipboard-text-clock",
        path: `${urlStart}/activity-log`,
        color: "dark",
      },
    ],
  };
};
